import SavedOrderServ from '@api/SavedOrders/SavedOrderServ';
import { SavedOrder } from '@api/SavedOrders/SavedOrder';
import { ShoppingCart } from '@api/ShoppingCart/ShoppingCart';
import { ShoppingCartV2 } from '@api/ShoppingCart/ShoppingCartV2';
import { SalesChannel } from '@api/SalesChannels/SalesChannel';

class SavedOrdersService {
    saveSavedOrder = (
        shoppingCart: ShoppingCart | ShoppingCartV2,
        savedOrderId?: string,
        salesChannel?: SalesChannel,
        schemaVersion?: 2
    ): Promise<SavedOrder> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await SavedOrderServ.saveSavedOrder(
                    shoppingCart,
                    savedOrderId,
                    salesChannel,
                    schemaVersion
                );
                resolve(data);
            } catch (error) {
                reject('Error saving saved order: ' + error);
            }
        });
    };
    getSavedOrders = (): Promise<SavedOrder[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await SavedOrderServ.getSavedOrders();
                resolve(data);
            } catch (error) {
                reject('Error getting saved orders: ' + error);
            }
        });
    };
    getSavedOrder = (savedOrderId: string): Promise<SavedOrder> => {
        return new Promise(async (resolve, reject) => {
            try {
                const savedOrder = await SavedOrderServ.getSavedOrder(savedOrderId);
                resolve(savedOrder);
            } catch (error) {
                reject('Error getting saved order: ' + error);
            }
        });
    };

    deleteSavedOrder = (savedOrderId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await SavedOrderServ.deleteSavedOrder(savedOrderId);
                resolve();
            } catch (error) {
                reject('Error deleting saved order: ' + error);
            }
        });
    };
}
export default SavedOrdersService;
